/* eslint-disable import/no-unresolved */
import { shape } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";

import * as i18nUtils from "util/i18n";

import Heading from "pages/_components/Heading";
import { Col } from "react-bootstrap";

import Hint from "pages/_components/hints/Hint";
import { selectors as transactionsSelectors } from "reducers/transactions";
import { selectors as transferSelectors } from "reducers/transfer";
import * as config from "util/config";
import { isFinalState } from "util/transaction";
import { getDebitAccountTicketLabel } from "util/accounts";

class ExternalTransactionData extends Component {
    static propTypes = {
        summary: shape({}).isRequired,
        getAccountInfo: shape({}).isRequired,
    };

    getAccountDescription = () => {
        const { getAccountInfo } = this.props;
        return getDebitAccountTicketLabel(getAccountInfo);
    };

    render() {
        const {
            summary: {
                idTransaction,
                debitAccount,
                creditAccount,
                beneficiaryDocumentNumber,
                beneficiaryName,
                bank,
                amount,
                reference,
                currency,
                concept,
                idActivityOriginal,
                email,
                emailText,
                sendEmail,
                idTransactionStatus,
                submitDateTime,
                tadTrx,
                voucher,
            },
            getAccountInfo,
        } = this.props;
        const transferCvuEnabled = config.getBoolean("transfer.cvu.enabled");
        const isCVU = !!creditAccount?.startsWith("000");
        const amountValue = amount?.quantity || amount;
        const currencyValue = currency?.toString() || (amount?.currency ? amount.currency.toString() : "");
        return (
            <Col xs={12} className="px-0">
                {isFinalState(idTransactionStatus) && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transferSummary.date.label"
                        data={
                            <p className="data-desc m-0">
                                <FormattedDate date={submitDateTime} dateFormat="dd/MM/yyyy" showTime />
                            </p>
                        }
                    />
                )}
                {idTransactionStatus === "FINISHED" && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transferConfirmation.voucher.label"
                        data={
                            <p className="data-desc m-0">{voucher ?? idTransaction?.substring(0, 8).toUpperCase()}</p>
                        }
                    />
                )}
                {idTransactionStatus !== "FINISHED" && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transferConfirmation.idTransaction.label"
                        data={<p className="data-desc m-0">{idTransaction?.substring(0, 8).toUpperCase()}</p>}
                    />
                )}

                <>
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transfers.debitAccount.label"
                        data={<p className="data-desc m-0">{debitAccount && this.getAccountDescription()}</p>}
                    />

                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transfers.creditAccount.label"
                        data={<p className="data-desc m-0">{creditAccount && creditAccount.slice(-14, -1)}</p>}
                    />
                </>
                {idActivityOriginal && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transactions.list.filters.transaction.activity.label"
                        data={<p className="data-desc m-0">{i18nUtils.get(`activity.${idActivityOriginal}`)}</p>}
                    />
                )}

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label={
                        transferCvuEnabled
                            ? `transferSummary.${!isCVU ? "cbu" : "cvu"}.label`
                            : "transferSummary.cbu.label"
                    }
                    data={<p className="data-desc m-0">{creditAccount}</p>}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transferSummary.cuit.label"
                    data={<p className="data-desc m-0">{beneficiaryDocumentNumber}</p>}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transferSummary.owner.label"
                    data={<p className="data-desc m-0">{beneficiaryName}</p>}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label={`transferSummary.${!isCVU ? "bank" : "entity"}.label`}
                    data={<p className="data-desc m-0">{bank}</p>}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transfers.amount.label"
                    data={<FormattedAmount currency={currencyValue} quantity={amountValue} notBold />}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transfers.concept.label"
                    data={
                        <p className="data-desc m-0">
                            {" "}
                            {`${concept} - ${i18nUtils.get(`transfers.concept.${concept}`)}`}
                        </p>
                    }
                />
                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transactions.list.item.date"
                    data={<p className="data-desc m-0">{i18nUtils.get("scheduler.executeToday")}</p>}
                />
                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transfers.reference.label"
                    data={<p className="data-desc m-0">{reference}</p>}
                />

                {getAccountInfo &&
                    getAccountInfo.idProduct &&
                    getAccountInfo.productType !== "CA" &&
                    idTransactionStatus !== "FAILED" &&
                    !tadTrx && (
                        <Hint
                            defaultValue={config.get(`transferencias.impuestos${getAccountInfo.productType}.Texto`)}
                            styleText={{
                                maxWidth: "35rem",
                            }}
                            classNameGroup="transfer__text-hint"
                            styleDiv={{ marginLeft: "0.5rem" }}
                            styleImage={{ alignSelf: "center", display: "flex" }}
                            classNameHintP="font-weight-normal my-0"
                            alwaysShowMessage
                        />
                    )}
                {sendEmail && email && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transfers.email.label"
                        data={<p className="data-desc m-0">{email}</p>}
                    />
                )}
                {sendEmail && email && emailText && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transfers.emailText.label"
                        data={<p className="data-desc m-0">{emailText}</p>}
                    />
                )}
            </Col>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: transactionsSelectors.getSummary(state),
    getAccountInfo: transferSelectors.getDebitAccount(state),
});

export default connect(mapStateToProps)(ExternalTransactionData);
